const { setInitialised, useArrows } = window.BAO.Carousel.plugins

export class PushCartRecommendations extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.onCartChanged = this.onCartChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )

    window.setTimeout(() => {
      const drawer = document.querySelector('site-drawer[key="cart"]')

      if (drawer?.hasAttribute('data-cart-empty')) return

      this.render()
    }, 500)
  }

  disconnectedCallback () {
    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged,
    )

    super.disconnectedCallback()
  }

  onCartChanged (event) {
    if (!this.isConnected) return

    const { state } = event.detail

    if (!state) return

    if (window.BAO.Cart.isCartEmpty(state)) {
      this.hideRecommendations()
      return
    }

    window.setTimeout(() => this.render(), 500)
  }

  hideRecommendations () {
    this.expanded = false

    document
      .querySelectorAll('.psh-Cart_Recommendations .psh-Recommendations')
      .forEach(container => {
        container.innerHTML = ''
      })

    if (this.isConnected) {
      this.innerHTML = ''
    }
  }

  render () {
    if (!this.url) return

    fetch(this.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div')
        html.innerHTML = text

        const recommendationsCheck = html.querySelector(
          '[data-push-cart-recommendations-carousel-el="slides"]',
        )
        const recommendations = html.querySelector('push-cart-recommendations')
        const hasItems =
          recommendations && recommendationsCheck?.innerHTML.trim().length

        if (hasItems) {
          document
            .querySelectorAll('.psh-Cart_Recommendations .psh-Recommendations')
            .forEach(container => {
              container.innerHTML = recommendations.innerHTML
            })

          if (this.isConnected) {
            this.innerHTML = recommendations.innerHTML
          }

          window.setTimeout(() => {
            document
              .querySelectorAll('push-cart-recommendations-carousel')
              .forEach(carousel => {
                if (typeof carousel.render === 'function') {
                  carousel.render()
                }
              })
          }, 150)
        }

        this.expanded = !!hasItems
      })
      .catch(e => {
        console.error(e)
      })
  }

  get expanded () {
    return this._expanded
  }

  set expanded (expanded) {
    this._expanded = expanded

    document
      .querySelector('site-drawer[key="cart"] .drw-Drawer_Aside')
      ?.setAttribute('aria-expanded', expanded ? 'true' : 'false')

    const mobileRecommendations = document.querySelector(
      '.psh-Cart_Recommendations',
    )

    if (mobileRecommendations) {
      if (expanded) {
        mobileRecommendations.setAttribute('loaded', 'true')
      } else {
        mobileRecommendations.removeAttribute('loaded')
      }
    }
  }

  get url () {
    return this.dataset.url
  }
}

if (!customElements.get('push-cart-recommendations')) {
  customElements.define('push-cart-recommendations', PushCartRecommendations)
}

class PushCartRecommendationsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    window.setTimeout(() => this.render(), 100)
  }

  setupListeners () {
    super.setupListeners()

    this.onResize = this.onResize.bind(this)
    window.addEventListener('resize', this.onResize)
  }

  disconnectedCallback () {
    window.removeEventListener('resize', this.onResize)
    this.destroyCarousel()
    super.disconnectedCallback()
  }

  render () {
    this.els = this.getElements(this._getElementIdentifiers())

    if (!this.els?.slide?.exists) return

    this.destroyCarousel()

    if (window.BAO.MediaBreakpoints.isMd) {
      this.els.slides.element.setAttribute('data-keen-slider-disabled', '')
      return
    }

    this.els.slides.element.removeAttribute('data-keen-slider-disabled')
    this.carousel = this.setupCarousel()
  }

  onResize () {
    const isMd = window.BAO.MediaBreakpoints.isMd

    if (isMd && this.carousel) {
      this.destroyCarousel()
      this.els.slides.element.setAttribute('data-keen-slider-disabled', '')
    } else if (!isMd && !this.carousel) {
      this.render()
    } else if (this.carousel) {
      this.carousel.update()
    }
  }

  destroyCarousel () {
    if (!this.carousel) return

    this.carousel.destroy()
    this.carousel = null
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1,
          spacing: 0,
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
          hideArrows: true,
        }),
      ],
    )
  }
}

if (!customElements.get('push-cart-recommendations-carousel')) {
  customElements.define(
    'push-cart-recommendations-carousel',
    PushCartRecommendationsCarousel,
  )
}
